import { render, staticRenderFns } from "./StorageAllot.vue?vue&type=template&id=594d67ae&scoped=true&"
import script from "./StorageAllot.vue?vue&type=script&lang=js&"
export * from "./StorageAllot.vue?vue&type=script&lang=js&"
import style0 from "./StorageAllot.vue?vue&type=style&index=0&id=594d67ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594d67ae",
  null
  
)

export default component.exports